import React from 'react'
import {Spin,  Timeline,  Button,message, Empty,} from 'antd';
import EssaModal from '@components/EssaModal/EssaModal';
import Lang from "@components/Lang/Lang";
import {isEmpty,trim} from '@utils/utils';
import {postDeliveryList, postDeliveryListInfo, postBatchDelivery,downloadDeliverOrder} from '@/api/warehouseManagement/outWarehouse';
import {postWaitIntoWarehouseList, postInserIntoWarehouse} from '@/api/warehouseManagement/registration'
import { toFixedWithCommas} from "@utils/number-util";
import Locale from "@utils/locale";
import FollowAction from "../Follow.action";
import dayjs from 'dayjs';
import "./index.less"
/**
 * 跟进记录
 *
 * @author FJJ
 * @version 1.0
 *
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class LogisticsFollowUp extends React.Component {
    static defaultProps = {
        containerId:"", //数据源
    }
    constructor(props) {
        super(props)
        this.state = {
            isModalVisible: false,
            loading:false,
            list:[],
            listTranslate:[],//翻译后的列表
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /*
    * 打开 并查询详情
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#7876
    * */
    open(flag=false){
        if(flag){
           this.getList()
        }
        this.setState({
            isModalVisible: flag
        })
    }
    getList(){
        const { buyerId} = this.props;
        if(buyerId){
            const data = {
                buyerId:buyerId
            }
            this.loading(true);
            FollowAction.getRemarkList(data).then(res=>{
                this.loading(false);
                const resData = res.data;
                const { success, valid,models} = resData;
                if (success &&valid) {
                    // 成功
                    this.setState({
                        list: models
                    })
                }else if(resData.message){
                    message.warning(resData.message)
                }else {
                    message.warning(Lang({id:"BaoCunShiBai"}))
                }
            }).catch(err=>{
                this.loading(false);
            })
        }

    }
    renderChild(list=[],isShowTranslateAfter){
        let childList = []
        list.forEach((item,inx)=>{
            childList.push({
                children: this.stepItem(item,inx,isShowTranslateAfter),
                color: inx==0?'red':'gray',
            })
        })
        return childList
    }
    stepItem(item={},index,isShowTranslateAfter) {
        const { listTranslate=[] } = this.state;
        return (
            <div className="fw_400 font_14 black45" key={"item_key_"+index}>
                <div className={"black89"}>
                    {isShowTranslateAfter&&listTranslate[index]?listTranslate[index].translatedText:item.remark}
                </div>
                <div className={"black45 font_12"}>
                    {item.createTime&&dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss')}<span className={"ml_6"}>{item.createByName}</span>
                </div>
            </div>
        )
    }
    /**
     * 翻译
     */
    translate(){
        const {listTranslate}= this.state;
        if(listTranslate&&listTranslate.length>0){
            this.showTranslate(true)
        }else {
            const {list=[]} = this.state;
            let postList = []
            list.forEach(item=>{
                postList.push(item.remark)
            })
            if(postList.length>0){
                const data = {
                    sourceList: postList,
                    targetLangs: [Locale.current()],
                    useModel:'common',//使用翻译模式（(common.通用翻译模型 goods.商品翻译模型)）
                    remark:window.location.href,
                }
                this.loading(true);
                FollowAction.getTranslate(data).then(res => this.handleRes(res.data)).catch(err => this.handleRes(err))
            }

        }
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,models} = res;
        if(success&&valid){
            this.setState({
                listTranslate:models,
            })
            this.showTranslate(true)
        }else if(res.message)message.warning(res.message);
    }
    showTranslate(flag=true){
        this.setState({
            isShowTranslateAfter: flag
        })
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const { children } = this.props;
        const {loading, isModalVisible, list,isShowTranslateAfter} = this.state;
        return (<>
                {children?<span onClick={()=>this.open(true)}>{children}</span>:<Button className={"ant-btn-primary-blue"}
                        onClick={()=>this.open(true)}>{Lang({id: "GenJinJiLu",default: "跟进记录"})}
                </Button>}
                {isModalVisible&&<EssaModal title={Lang({id:"GenJinJiLu",default:"跟进记录"})}
                                            open={isModalVisible}
                                            footer={null}
                                            width={550}
                                            onCancel={()=>this.open(false)}
                                            onOk={()=>this.open()}>
                    <Spin spinning={loading}>
                        {list.length>0?<>
                            <div className={"mb_10"}>
                                <a className={"color-blue"} onClick={()=>this.translate()}>
                                    <span>{Lang({id: 'FanYi', default: '翻译'})}</span>
                                </a>
                                <span className="ml_12 color-blue cursor-p" onClick={()=>this.showTranslate(false)}>
                                <span>{Lang({id: 'XianShiYuanWen', default: '显示原文'})}</span>
                            </span>
                            </div>
                            <div className={'modalLogisticsWrap'}>
                                <Timeline items={this.renderChild(list,isShowTranslateAfter)} />
                            </div>
                            </>:<div className={"mt_16"}>
                            <Empty mage={Empty.PRESENTED_IMAGE_SIMPLE} description={Lang({id: 'ZanWuShuJu',default:'暂无数据'})} />
                        </div>}
                    </Spin>
                </EssaModal>}
            </>
        )
    }
}